import React from 'react'
import propTypes from 'prop-types'
import { connect } from 'react-redux'
import { Icon, MenuItem, Spinner } from '@blueprintjs/core'

import InputSelect from './InputSelect'
import {
    getContactsSearchResults,
    getCmdbContacts,
} from 'src/store/modules/cmdb/contacts'

const customerRenderer = (user, { handleClick, modifiers }) => {
    return (
        <MenuItem
            active={modifiers.active}
            key={user.id}
            text={user.fullName}
            onClick={handleClick}
        />
    )
}

class UserSelect extends React.Component {
    renderInputValue = (customer) => {
        return `${customer.fullName} - ${customer.userName}`
    }

    componentDidMount() {
        this.props.getCmdbContacts('', '?exists_only=true')
    }

    render() {
        const {
            selected,
            customers,
            loading,
            fill,
            getCmdbContacts,
            onTeamSelect,
            large,
        } = this.props

        return (
            <InputSelect
                inputProps={{
                    placeholder: 'Search for a user',
                    large,
                    rightElement: loading ? (
                        <Spinner size={Icon.SIZE_STANDARD} />
                    ) : null,
                }}
                itemRenderer={customerRenderer}
                noResults={
                    loading ? (
                        <MenuItem disabled text={'Loading...'} />
                    ) : (
                        <MenuItem disabled text="No results" />
                    )
                }
                items={customers}
                inputValueRenderer={this.renderInputValue}
                onQueryChange={(value) =>
                    getCmdbContacts(value, '?exists_only=true')
                }
                popoverProps={{
                    minimal: true,
                    targetClassName: fill ? 'full-width' : '',
                }}
                onItemSelect={(customer) => onTeamSelect(customer)}
                selectedItem={selected}
            />
        )
    }
}

UserSelect.propTypes = {
    onTeamSelect: propTypes.func.isRequired,
    getCmdbContacts: propTypes.func.isRequired,
    selected: propTypes.shape({
        name: propTypes.string.isRequired,
        id: propTypes.number.isRequired,
    }),
    large: propTypes.bool,
    fill: propTypes.bool,
}

UserSelect.defaultProps = {
    large: false,
    fill: true,
}

export default connect(
    (state) => ({
        customers: getContactsSearchResults(state),
        loading: state.cmdb.contacts.loading,
    }),
    { getCmdbContacts }
)(UserSelect)
